import React from 'react';
import { Box, Typography } from '@mui/material';
import { type DossierOpenSearch } from '@europrocurement/l2d-domain';
import { useStatusStyle } from '@europrocurement/l2d-modules/hooks';
import { InformationChip } from '@europrocurement/flexy-components';
import useDossierProcesses from '../../../hooks/useDossierProcesses';
import { VALIDATOR_TYPE_GREFFE } from '../../../constants/validators';

export type DossierCanaProps = {
    dossier: DossierOpenSearch;
};

const DossierCanal: React.FunctionComponent<DossierCanaProps> = function ({ dossier }) {
    const { getCurrentProcessOfType } = useDossierProcesses();
    const valideurGreffe = getCurrentProcessOfType(dossier, VALIDATOR_TYPE_GREFFE);
    const { getValidatorStatusStyle } = useStatusStyle();

    let iconPropStatus;
    let sxStatusStyle;

    if (valideurGreffe) {
        const { iconProp, sxStatus } = getValidatorStatusStyle(valideurGreffe?.statusFlag);

        // console.log(iconProp, sxStatus);
        iconPropStatus = iconProp;
        sxStatusStyle = sxStatus;
    }

    return (
        <Typography
            variant="l2dtableCell"
            color="text.gris50"
        >
            {valideurGreffe && (
                <InformationChip
                    icon={iconPropStatus}
                    sx={{ ...sxStatusStyle, display: 'flex', alignItems: 'center' }}
                    sxIcon={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                    label={
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="l2dbodyxs">
                                {valideurGreffe.validatorLabel}
                            </Typography>
                            <Typography
                                variant="l2dbodys"
                                sx={{ marginTop: '-4px' }}
                            >
                                {valideurGreffe.statusLabel}
                            </Typography>
                        </Box>
                    }
                />
            )}
        </Typography>
    );
};

export default DossierCanal;
